import React from 'react';

class EmptyCheckbox extends React.Component {
  render(){
    return(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="16"
      >
        <g
          id="checkbox/empty"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            id="Rectangle"
            stroke="#545454"
            x="0.5"
            y="0.5"
            width="15"
            height="15"
          />
        </g>
      </svg>
    );
  }
}

export default EmptyCheckbox;
